import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import * as yup from 'yup';
import { withAsyncActions, withAsyncHandlers } from 'react-async-client';
import { Field } from 'react-final-form';
import { Row, Col, Button, Alert } from 'antd';
import Translate from 'react-translate-component';

import withFormWrapper from 'components/hocs/withFormWrapper';
import { changeUserPassword } from 'actions/asyncActions';
import Input from 'components/common/form/Input';
import ErrorHTML from 'components/common/form/ErrorHTML';

const validationSchema = yup.object().shape({
    currentPassword: yup.string().required(),
    newPassword: yup.string()
                    .match('passwordRepeat', 'passwordsMustMatch')
                    .range(6, 15, 'passwordLength')
                    .required(),
    passwordRepeat: yup.string()
                    .match('newPassword', 'passwordsMustMatch')
                    .range(6, 15, 'passwordLength')
                    .required()
});

@withAsyncActions({ formAction: changeUserPassword }, { autoReset: true })
@withFormWrapper({ validationSchema: validationSchema })
@withAsyncHandlers({
    formAction: {
        successHandler: props => {
            props.form.reset();
        }
    }
})
export default class ProfileForm extends Component {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        formAction: PropTypes.object.isRequired,
    }

    render() {
        const { meta } = this.props.formAction;

        return (
            <Fragment>
                <Field
                    name='currentPassword'
                    component={Input}
                    type='password'
                    label={{ content: 'profile.form.currentPassword' }}
                    placeholder={'placeholders.currentPassword'}
                />
                <Field
                    name='newPassword'
                    component={Input}
                    type='password'
                    label={{ content: 'profile.form.newPassword' }}
                    placeholder={'placeholders.newPassword'}
                />
                <Field
                    name={'passwordRepeat'}
                    component={Input}
                    type='password'
                    label={{ content: 'profile.form.passwordRepeat' }}
                    placeholder={'placeholders.passwordRepeat'}
                />
                <Row className="profile-button">
                    <Col xs={ {span: 16, offset: 8} }>
                        <Button htmlType="submit" type="blue" disabled={meta.pending}>
                            <Translate content='profile.form.updatePassword' />
                        </Button>
                    </Col>
                </Row>
                { meta.success && (
                    <Alert type="success" message={<Translate content='profile.form.passwordChangeSuccess' />} />
                )}
                { meta.error && (
                    <ErrorHTML meta={meta} />
                )}
            </Fragment>
        );
    }
}
